import React from 'react';
import { Users, Wrench, Award } from 'lucide-react';
import PageBanner from '../layout/PageBanner';
import SectionHeading from '../ui/SectionHeading';
import { mirageDifference } from '../../data/company';

const MirageDifferencePage = () => {
  return (
    <div>
      <PageBanner
        title="THE MIRAGE DIFFERENCE"
        breadcrumbs={[{ label: 'THE MIRAGE DIFFERENCE' }]}
      />

      <section className="py-16 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Who We Are */}
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-primary-red rounded-full flex items-center justify-center mx-auto mb-6">
                <Users size={32} className="text-white" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-4">Who We Are</h3>
              <p className="text-gray-600 leading-relaxed">
                {mirageDifference.whoWeAre}
              </p>
            </div>

            {/* What We Do */}
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-primary-red rounded-full flex items-center justify-center mx-auto mb-6">
                <Wrench size={32} className="text-white" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-4">What We Do</h3>
              <p className="text-gray-600 leading-relaxed">
                {mirageDifference.whatWeDo}
              </p>
            </div>

            {/* Our Credentials */}
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-primary-red rounded-full flex items-center justify-center mx-auto mb-6">
                <Award size={32} className="text-white" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-4">Our Credentials</h3>
              <p className="text-gray-600 leading-relaxed">
                {mirageDifference.credentials}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MirageDifferencePage;
